var _path, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnverified = function SvgUnverified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 11.2C8.69279 11.2 11.2 8.69279 11.2 5.6C11.2 2.50721 8.69279 0 5.6 0C2.50721 0 0 2.50721 0 5.6C0 8.69279 2.50721 11.2 5.6 11.2Z",
    fill: "#982400"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.45365,
    y1: 2.64645,
    x2: 8.45365,
    y2: 8.64645,
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2.74653,
    y1: 8.64646,
    x2: 8.74615,
    y2: 2.64648,
    stroke: "white"
  })));
};
export default SvgUnverified;